import { useNavigate } from 'react-router-dom';
import { useNotificationBellStatus } from '@/lib/core/hooks/useNotificationBellStatus';

interface NotificationBellProps {
  color?: string;
}

export function NotificationBell({ color = 'white' }: NotificationBellProps) {
  const navigate = useNavigate();
  const status = useNotificationBellStatus();

  return (
    <button
      className="flex size-11 items-center justify-center rounded-[52px]"
      aria-label="Notifications"
      onClick={() => navigate('/notifications/inbox')}
    >
      {status === 'empty' && (
        <svg width="22" height="24" viewBox="0 0 22 24" fill="none" aria-hidden="true">
          <path
            d="M11 1C12.7546 1 14.4372 1.73561 15.6777 3.04492C16.9181 4.35423 17.6152 6.13043 17.6152 7.98242C17.6152 12.1745 18.4663 14.8818 19.3262 16.5459C19.7559 17.3775 20.1876 17.9472 20.5137 18.3105C20.5923 18.3981 20.6646 18.4738 20.7295 18.5381H1.27051C1.33536 18.4738 1.40773 18.3981 1.48633 18.3105C1.81241 17.9472 2.2441 17.3775 2.67383 16.5459C3.53372 14.8818 4.38477 12.1745 4.38477 7.98242C4.38484 6.13043 5.08189 4.35423 6.32227 3.04492C7.56277 1.73561 9.2454 1 11 1Z"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.62366 21.3258C9.02789 21.0938 9.54567 21.23 9.78016 21.63C9.90413 21.8415 10.0821 22.017 10.2961 22.139C10.5102 22.2611 10.753 22.3253 11 22.3253C11.2471 22.3253 11.4898 22.2611 11.7039 22.139C11.918 22.017 12.0959 21.8415 12.2199 21.63C12.4544 21.23 12.9722 21.0938 13.3764 21.3258"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {status === 'read' && (
        <svg width="22" height="24" viewBox="0 0 22 24" fill="none" aria-hidden="true">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.59616 2.35748C7.01947 0.85507 8.96202 0 11 0C13.038 0 14.9805 0.85507 16.4038 2.35748C17.8254 3.85806 18.6153 5.88238 18.6153 7.98271C18.6153 12.0361 19.4374 14.582 20.2149 16.0866C20.6044 16.8405 20.9865 17.3402 21.2576 17.6423C21.3934 17.7936 21.5019 17.896 21.5705 17.9563C21.6048 17.9865 21.6292 18.0062 21.642 18.0162L21.6518 18.0238C21.9464 18.236 22.0709 18.6114 21.9598 18.9555C21.8479 19.3025 21.522 19.5381 21.1538 19.5381H0.846209C0.478048 19.5381 0.152139 19.3025 0.0401536 18.9555C-0.0708747 18.6114 0.0536465 18.236 0.348191 18.0238L0.358032 18.0162C0.370832 18.0062 0.395182 17.9865 0.42949 17.9563C0.498075 17.896 0.606631 17.7936 0.742403 17.6423C1.01352 17.3402 1.39559 16.8405 1.78514 16.0866C2.56261 14.582 3.38466 12.0361 3.38466 7.98271C3.38466 5.88238 4.17458 3.85806 5.59616 2.35748Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.62366 21.3258C9.02789 21.0938 9.54567 21.23 9.78016 21.63C9.90413 21.8415 10.0821 22.017 10.2961 22.139C10.5102 22.2611 10.753 22.3253 11 22.3253C11.2471 22.3253 11.4898 22.2611 11.7039 22.139C11.918 22.017 12.0959 21.8415 12.2199 21.63C12.4544 21.23 12.9722 21.0938 13.3764 21.3258C13.7806 21.5579 13.9182 22.0703 13.6837 22.4703C13.411 22.9356 13.0195 23.3218 12.5485 23.5902C12.0776 23.8587 11.5436 24 11 24C10.4565 24 9.92249 23.8587 9.4515 23.5902C8.98051 23.3218 8.58905 22.9356 8.31632 22.4703C8.08183 22.0703 8.21944 21.5579 8.62366 21.3258Z"
            fill={color}
          />
        </svg>
      )}
      {status === 'unread' && (
        <svg width="27" height="29" viewBox="0 0 27 29" fill="none" aria-hidden="true">
          <path
            d="M22 0C24.7614 0 27 2.23858 27 5C27 7.76142 24.7614 10 22 10C19.2386 10 17 7.76142 17 5C17 2.23858 19.2386 0 22 0Z"
            fill="#E02020"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.96026 9.11156C8.22184 7.76587 9.94365 7 11.7501 7C13.5565 7 15.2783 7.76587 16.5398 9.11156C17.7999 10.4556 18.5001 12.2688 18.5001 14.15C18.5001 17.7806 19.2287 20.0609 19.9178 21.4085C20.2631 22.0838 20.6018 22.5314 20.8421 22.802C20.9624 22.9375 21.0586 23.0292 21.1194 23.0832C21.1498 23.1102 21.1714 23.1279 21.1828 23.1369L21.1915 23.1437C21.4526 23.3337 21.5629 23.6699 21.4645 23.9781C21.3653 24.289 21.0764 24.5 20.7501 24.5H2.75005C2.42373 24.5 2.13485 24.289 2.03559 23.9781C1.93718 23.6699 2.04755 23.3337 2.30863 23.1437L2.31735 23.1369C2.32869 23.1279 2.35028 23.1102 2.38069 23.0832C2.44148 23.0292 2.5377 22.9375 2.65804 22.802C2.89835 22.5314 3.23701 22.0838 3.5823 21.4085C4.27142 20.0609 5.00005 17.7806 5.00005 14.15C5.00005 12.2688 5.70021 10.4556 6.96026 9.11156Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.64374 26.1012C10.002 25.8934 10.461 26.0154 10.6688 26.3737C10.7787 26.5631 10.9364 26.7203 11.1262 26.8296C11.3159 26.9389 11.5311 26.9965 11.7501 26.9965C11.9691 26.9965 12.1842 26.9389 12.374 26.8296C12.5637 26.7203 12.7214 26.5631 12.8313 26.3737C13.0392 26.0154 13.4981 25.8934 13.8564 26.1012C14.2147 26.3091 14.3367 26.768 14.1288 27.1263C13.8871 27.5431 13.5401 27.889 13.1226 28.1294C12.7052 28.3699 12.2318 28.4965 11.7501 28.4965C11.2683 28.4965 10.795 28.3699 10.3775 28.1294C9.96004 27.889 9.61306 27.5431 9.37132 27.1263C9.16348 26.768 9.28545 26.3091 9.64374 26.1012Z"
            fill={color}
          />
        </svg>
      )}
    </button>
  );
}
